import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Typography, Box } from '@material-ui/core';
// import { MenuItem, TextField } from '@material-ui/core';
// It is set from v5 material ui instead of v4 because 
// MenuItem does not cover the TextField
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import ButtonLoading from '../ButtonLoading/ButtonLoading';

import { getFromSafeObject, textTransform, textTruncate } from '../../aux/aux';

import LanguageIcon from '@mui/icons-material/Language';
import Circle from '../../img/circle.svg';

import './classContentLanguageEdit.css';
import { useTheme } from '@material-ui/styles';
import ToggleMsg from '../ToggleMsg/ToggleMsg';

const ClassContentLanguageEdit = ({ userConfig, contentSummary, onUpdate=async()=>{}, autoCloseModal=()=>{}}) => {
    const TEXT_TRUNCATE_LENGTH = 35;
    const TEXT_TRUNCATE_END = '...';
    const theme = useTheme();
    const { t } = useTranslation('common', { keyPrefix: 'classContentLanguageEdit' });
    const abortControllerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLocaleId, setSelectedLocaleId] = useState(userConfig.localeId ? userConfig.localeId : null );
    const [error, setError] = useState({isError:false, msg:undefined, onError:undefined});

    const handleOnUpdate = async (e, signal=abortControllerRef.current.signal) => {
        e.preventDefault();
        try{
            setIsLoading(true);
            const requestContent = true;
            const requestUpdatedConfig = true
            await onUpdate({localeId: selectedLocaleId}, requestContent, requestUpdatedConfig)
            if(!signal.aborted){
                autoCloseModal()
            }
        }catch(error){
            if(!signal.aborted){
                setError({
                    isError:true, 
                    msg:`${textTransform('title', t('cannotUpdateTheSelectedLanguage'))}. ${textTransform('title', t('tryItLater'))}`,
                    onError: () => setError(prev => ({...prev, isError:false, onError:undefined}))
                })
            }
        }finally{
            if(!signal.aborted){
                setIsLoading(false);
            }
        }
    }

    const getLocaleNameFromAPILocaleObject = (APIlocaleObject) => {
        const languageName = APIlocaleObject.details.language.description.name;
        const countryName =  APIlocaleObject.details.country.description.name;
        return textTransform('capitalize', `${languageName} ${countryName ? `(${countryName})`: ''}`)
    }

    useEffect(() => {
        const abortController = new AbortController();
        abortControllerRef.current = abortController;
        return(() => {
            abortController.abort()
        })
    },[])

    return (
        <Grid container direction='column' className='class-content-language-edit-main'>
            <Grid item container className='class-content-language-edit-header'>
                <LanguageIcon className='class-content-language-edit-header-icon'/>
                <Typography variant='body1' style={{fontWeight:'bold'}}>
                    {textTransform('capitalize', t('common:language', {count: 1}))}
                </Typography>
            </Grid>
            <Divider />
            <Grid item container direction='column' className='class-content-language-edit-form'>
                <form onSubmit={handleOnUpdate}>
                    <Grid item>
                        <TextField 
                        label={t('selectLanguage')}
                        disabled={isLoading}
                        name='laguageCode'
                        value={selectedLocaleId}
                        onChange={(e) => setSelectedLocaleId(e.target.value)} 
                        inputProps={{style:{textOverflow:'ellipsis'}}}
                        select 
                        fullWidth
                        variant='standard'
                        >
                            {getFromSafeObject(contentSummary, 'summaryDetails.availableConfiguration.localeArray', []).map( (locale, index) => {
                                return(
                                    <MenuItem key={index} value={locale.localeId}>
                                        <Grid container >
                                            <Grid item>
                                                <Typography display='inline' variant='body1'>
                                                    {textTruncate(getLocaleNameFromAPILocaleObject(locale.details.locale), TEXT_TRUNCATE_LENGTH, TEXT_TRUNCATE_END)}
                                                </Typography>
                                            </Grid>
                                            <Grid item style={{padding: '0px 10px'}}>
                                                {userConfig.localeId === locale.localeId &&
                                                    <Circle height={'0.5em'} fill={theme.palette.primary.main}/>
                                                }
                                            </Grid>
                                        </Grid>
                                    </MenuItem>
                                )
                            })}
                        </TextField>
                    </Grid>
                    <Grid item className='class-content-language-edit-form-button'>
                        <ButtonLoading type="submit" disabled={selectedLocaleId == null || selectedLocaleId === userConfig.localeId || isLoading} isLoading={isLoading} label={t('common:select')} 
                        variant="outlined" color="primary" fullWidth/>
                    </Grid>
                </form>
                <ToggleMsg 
                    isShown={error.isError} 
                    msg={error.msg} 
                    onShowTime={error.onError}
                    type='error' 
                />
            </Grid>
        </Grid>
    )
}

export default ClassContentLanguageEdit